<template>
  <a-form @submit="handleSubmit" :form="form" class="form">
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item label="法人名称">
          <a-input
            placeholder="请输入法人名称"
            v-decorator="[
              'legalName',
              {rules: [{ required: true, message: '请输入法人名称', whitespace: true},{ pattern: /^\S*$/,message: '不允许输入空格'}], initialValue:enterprise.legalName}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="法人类别">
          <j-dict-select-tag
            placeholder="请选择法人类别"
            dictCode="bidder_code_type"
            :triggerChange="true"
            v-decorator="[
              'bidderCodeType',
              {rules: [{ required: true, message: '请选择法人类别', whitespace: true}], initialValue:enterprise.bidderCodeType}
            ]"
          />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="主体类型">
          <j-multi-select-tag
            placeholder="请选择主体类型"
            mode="multiple"
            dictCode="legal_role"
            :triggerChange="true"
            v-decorator="[
              'legalRole',
              {rules: [{ required: true, message: '请选择主体类型', whitespace: true}], initialValue:enterprise.legalRole}
            ]"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item label="法人代码">
          <a-input
            placeholder="请输入法人代码"
            @change="handleChangeLegalCode"
            v-decorator="[
              'legalCode',
              {rules: [{ required: true, message: '请输入法人代码', whitespace: true},{ type: 'string', max: 18,min:18, message: '只能18个字符' }] ,initialValue:enterprise.legalCode}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item label="组织机构代码">
          <a-input
            placeholder="请输入组织机构代码"
            :readOnly="isReadOnly"
            v-decorator="[
              'organNo',
              {rules: [{ required: true, message: '请输入组织机构代码', whitespace: true}],initialValue:enterprise.organNo}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 9, offset: 1}" :lg="{span: 10}" :md="{span: 24}" :sm="24">
        <a-form-item
          label="组织机构代码证失效日期">
          <a-date-picker
            v-decorator="[
              'organCertEndDate',
              {rules: [{ required: true, message: '请选择组织机构代码证失效日期'}], initialValue:enterprise.organCertEndDate}
            ]"
            format="YYYY-MM-DD">
            <!--<template slot="dateRender" slot-scope="current, today">
              <div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
                {{ current.date() }}
              </div>
            </template>-->
          </a-date-picker>
        </a-form-item>
      </a-col>
    </a-row>

    <a-form-item v-if="showSubmit">
      <a-button htmlType="submit" >Submit</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
  export default {
    name: "EnterpriseBasicForm",
    props: {
      showSubmit: {
        type: Boolean,
        default: false
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      enterprise: {
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data () {
      return {
        form: this.$form.createForm(this)
      }
    },
    created() {
      //console.log("页面参数",this);
    },
    methods: {
      handleChangeLegalCode(){
        let that = this;
        setTimeout(function(){
          that.form.setFieldsValue({"organNo":that.form.getFieldValue("legalCode")});
          }, 100);
      },
      handleSubmit (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            this.$notification['error']({
              message: 'Received values of form:',
              description: values
            })
          }
        })
      },
      getCurrentStyle(current, today) {
        const style = {};
        if (current.date() === 1) {
          style.border = '1px solid #1890ff';
          style.borderRadius = '50%';
        }
        return style;
      },
    }
  }
</script>

<style scoped>

</style>